// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bold{font-weight:700}.mt-1{margin-top:50px}.mb-1{margin-bottom:50px}.select-wrapper,select{position:relative}select{border-color:rgba(255,67,0,.9);border-radius:8px;width:100%}select:disabled{border-color:#ccc;cursor:auto}select+i{position:absolute;right:30px;top:38px}.multi-select{padding:0}select.multi-select option{border:none;border-bottom:1px solid #ccc;padding-left:10px;padding-right:10px}.multi-select-alert{margin-top:10px}", ""]);
// Exports
module.exports = exports;
